var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 47.1 49.52" }
    },
    [
      _c("defs"),
      _vm._v(" "),
      _c("g", [
        _c("g", [
          _c("polyline", {
            staticClass: "cls-1",
            attrs: {
              points:
                "38.61 11.27 1.34 11.27 5.82 37.45 34.36 37.45 40.73 1.13 47.1 1.13"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "cls-2",
            attrs: {
              d:
                "M13.29,45.65a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,13.29,45.65Z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "cls-2",
            attrs: {
              d:
                "M34.81,45.65a3.87,3.87,0,1,1-3.87-3.87A3.87,3.87,0,0,1,34.81,45.65Z"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }